import { Select, SelectItem } from '@carbon/react'
import type { FormSelectProps } from './types'
import { FormFieldLabel } from './FormFieldLabel'
import styles from './FormField.module.scss'

export function FormSelect({
  label,
  required,
  options,
  error,
  hint,
  value,
  onValueChange,
  placeholder = 'Sélectionner...',
  className = '',
  name,
  id,
  disabled = false,
}: FormSelectProps) {
  const fieldId = id || name || `select-${Math.random()}`

  const selectValue =
    value !== undefined && value !== null && value !== '' ? String(value) : ''

  if (!Array.isArray(options)) {
    console.error(
      `[FormSelect:${name}] "options" doit être un tableau`,
      options
    )
    return null
  }

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={styles.fieldWrapper}>
        <Select
          id={fieldId}
          size="md"
          value={selectValue}
          onChange={e => onValueChange(e.target.value)}
          disabled={disabled}
          labelText={<FormFieldLabel label={label} required={required} />}
          invalid={!!error}
          invalidText={error}
          helperText={hint && !error ? hint : undefined}
        >
          <SelectItem
            value=""
            text={placeholder}
            disabled={required}
            hidden={required}
          />
          {options.length === 0 && !placeholder ? (
            <SelectItem value="" text="Aucune option disponible" disabled />
          ) : (
            options.map(option => (
              <SelectItem
                key={String(option.value)}
                value={String(option.value)}
                text={option.label}
              />
            ))
          )}
        </Select>
      </div>
    </div>
  )
}
